import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClustersComponent } from './clusters.component';
import { RouterModule, Routes } from "@angular/router";
import { CustomTableModule } from 'src/app/shared/components/custom-table/custom-table.module';
import { ImageModule } from 'src/app/shared/components/image/image.module';
import { FeaturedClusterModule } from "@/shared/pipes/featured-cluster/featured-cluster.module";
import { DateSortingSelectModule } from "@/shared/components/date-sorting-select/date-sorting-select.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ClusterDetailsModalComponent } from "@/modules/clusters/components/cluster-details-modal/cluster-details-modal.component";
import { ClusterCollaboratorsComponent } from "@/modules/clusters/components/cluster-details-modal/components/cluster-collaborators/cluster-collaborators.component";
import { ClusterInvitesComponent } from "@/modules/clusters/components/cluster-details-modal/components/cluster-invites/cluster-invites.component";
import { ClusterAddCollaboratorComponent } from "@/modules/clusters/components/cluster-details-modal/components/cluster-collaborators/modal/cluster-add-collaborator/cluster-add-collaborator.component";
import { ClusterSendEmailComponent } from "@/modules/clusters/components/cluster-details-modal/components/cluster-invites/modal/cluster-send-email/cluster-send-email.component";
import { ButtonModule } from "@airnauts/ng-components/button";
import { CustomSectionModule } from "@/shared/components/custom-section/custom-section.module";
import { ClusterElementsComponent } from "@/modules/clusters/components/cluster-details-modal/components/cluster-elements/cluster-elements.component";
import { SwitchButtonModule } from "@airnauts/ng-components/switch-button";
import { InputModule } from "@airnauts/ng-components/input";
import { SelectModule } from "@airnauts/ng-components/select";
import { SectionModule } from "@/shared/components/section/section.module";
import { MatDialogModule } from "@angular/material/dialog";
import { ConfirmDialogModule } from "@/shared/components/confirm-dialog/confirm-dialog.module";
import { MatButtonModule } from "@angular/material/button";
import { TableModule } from "@/shared/components/table/table.module";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatIconModule } from "@angular/material/icon";
import {
  ClusterSummaryComponent,
} from "@/modules/clusters/components/cluster-details-modal/components/cluster-summary/cluster-summary.component";
import { ExpandablePanelModule } from "@/shared/components/accordion/expandable-panel.module";

@NgModule({
  declarations: [
    ClustersComponent,
    ClusterDetailsModalComponent,
    ClusterElementsComponent,
    ClusterCollaboratorsComponent,
    ClusterInvitesComponent,
    ClusterAddCollaboratorComponent,
    ClusterSendEmailComponent,
    ClusterSummaryComponent,
  ],
  imports: [
    CommonModule,
    TableModule,
    CustomTableModule,
    SectionModule,
    ButtonModule,
    CustomSectionModule,
    ImageModule,
    FeaturedClusterModule,
    DateSortingSelectModule,
    ReactiveFormsModule,
    SwitchButtonModule,
    InputModule,
    SelectModule,
    SectionModule,
    MatDialogModule,
    ConfirmDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
    FormsModule,
    MatIconModule,
    ExpandablePanelModule,
  ],
})
export class ClustersModule { }
